import toggle_class from "frontend/dom/toggle_class"
import can_hover from "frontend/features/can_hover"
import register_dom_update from "frontend/navigation/register_dom_update"
import is_firefox from "frontend/utils/is_firefox"

register_dom_update({
  after: () => {
    toggle_class(document.body, {
      "can-hover": can_hover(),
      "is-firefox": is_firefox(),
    })
  },
})
